import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EvaluationEmployeeNineGrid } from '@qaroni-shared/types/evaluation-employee-nine-grid';

@Component({
  selector: 'qaroni-matrix-nine-grid-box',
  templateUrl: './matrix-nine-grid-box.component.html',
  styleUrl: './matrix-nine-grid-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MatrixNineGridBoxComponent {
  readonly message = input<string>('');
  readonly employees = input<EvaluationEmployeeNineGrid[]>([]);
}
